import ImagesStyle from '@/Styles/images.js';
import { Box, Link as MuiLink, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { memo, useCallback } from 'react';

const YaKHeaderHeadings = () => {
    const styles = {
        headings_container: {
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-end' },
        },
        headings: (theme) => ({
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            whiteSpace: 'nowrap',
            color: 'inherit',
            boxShadow: { xs: '0 0 20px rgba(0, 0, 0, 0.15)', md: '-20px 7px 20px rgba(0, 0, 0, 0.15)' },
            pl: { xs: 3, md: 6, xl: 9 },
            '.header-headings-highlighted-word': {
                transition: 'color 0.4s ease-in-out',
            },
            '.header-headings-icon-container': {
                transition: 'all 0.4s ease-in-out',
            },
            '&:hover': {
                '.header-headings-highlighted-word': {
                    color: theme.palette.primary.main,
                },
                '.header-headings-icon-container': {
                    transform: 'translateY(-10%)',
                },
            },
        }),
        heading_text_block: {
            display: { xs: 'flex', md: 'flex' },
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: { md: 90, xl: 110 },
        },
        heading_highlighted: {
            display: 'inline-block',
            ['@media (max-width: 319.98px)']: {
                fontSize: '1rem',
            },
            ['@media (min-width: 1200px) and (max-width: 1275.98px)']: {
                fontSize: '1.25rem',
            },
        },
        heading: {
            display: 'inline-block',
            ['@media (max-width: 319.98px)']: {
                fontSize: '0.875rem',
            },
            ['@media (min-width: 1200px) and (max-width: 1275.98px)']: {
                fontSize: '1rem',
            },
        },
        headings_icon: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pt: { xs: 0.5, md: 0 },
            pb: { xs: 1, md: 0 },
            pl: { xs: 1, md: 0 },
            m: { md: '0 30px' },
            width: { xs: 60, sm: 74 },
            height: { md: 55 },
        },
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleMobileClick = useCallback((e) => {
        // If the target section exists on the current page, smooth scroll instead of navigating
        const target = document.getElementById('land-fieldset');
        if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        }
    }, []);

    const BannerContent = (
        <>
            <Box component={'span'} sx={styles.heading_text_block}>
                <Typography
                    variant="fancy_subtitle1"
                    className="header-headings-highlighted-word"
                    sx={styles.heading_highlighted}
                >
                    configurez&nbsp;
                </Typography>
                <Typography variant="subtitle2" sx={styles.heading}>
                    votre futur projet de construction
                </Typography>
            </Box>
            <Box component={'span'} className="header-headings-icon-container" sx={styles.headings_icon}>
                <img src={'/theme/ya-k/images/icons/menu-maison.png'} alt="" style={ImagesStyle.contain_center} />
            </Box>
        </>
    );

    return (
        <Box sx={styles.headings_container}>
            {isMobile ? (
                <MuiLink
                    href={`${route('configurator.index')}#land-fieldset`}
                    underline="none"
                    sx={styles.headings}
                    onClick={handleMobileClick}
                >
                    {BannerContent}
                </MuiLink>
            ) : (
                <Box sx={styles.headings}>{BannerContent}</Box>
            )}
        </Box>
    );
};
export default memo(YaKHeaderHeadings);
